// **  Initial State
const initialState = {
  tagsData: {},
  hasComponentMountedOnce: false,
  isLoading: true,
}

const productTagsReducer = (state = initialState, action) => {
  switch (action.type) {
    case "ADD_NEW_PRODUCT_TAG": {
      const newData = { ...state.tagsData }
      action.data.forEach((e) => {
        newData[e.id] = e.value
      })
      return { ...state, tagsData: newData }
    }
    case "UPDATE_PRODUCT_TAG": {
      const newData = { ...state.tagsData }
      newData[action.data.id] = action.data.value
      return { ...state, tagsData: newData }
    }

    case "DELETE_PRODUCT_TAG": {
      const newData = { ...state.tagsData }
      delete newData[action.data]
      return { ...state, tagsData: newData }
    }

    case "SET_PRODUCT_TAG_LOADING": {
      return { ...state, isLoading: action.data }
    }

    case "SET_PRODUCT_TAG_MOUNTED": {
      return { ...state, hasComponentMountedOnce: true }
    }

    default:
      return state
  }
}

export default productTagsReducer
